import { Injectable } from "@angular/core";
import { OrderHistory } from "src/services/history/history.types";
import { logSentry } from "src/services/utils/sentry.utils";
import { apiPath, orderHistoryEndpoint } from "../../shared/api-path.const";
import { ApiService } from "../http/api.service";

@Injectable({
  providedIn: "root",
})
export class OrderHistoryService {
  constructor(private readonly apiService: ApiService) {}

  public async getHistoryByOrderId(orderId: string): Promise<OrderHistory[]> {
    return this.apiService.sendGetRequest<OrderHistory[]>(`${apiPath.order}/${orderId}/${apiPath.history}`, undefined);
  }

  public logAddedToCalendar(orderId: string): void {
    const path = `${apiPath.order}/${orderId}/${apiPath.history}/${orderHistoryEndpoint.addedToCalendar}`;

    this.apiService.sendPostRequest<undefined, never>(path, undefined).catch((error) => logSentry(error));
  }
}
